import { render, staticRenderFns } from "./DownLoadTip.vue?vue&type=template&id=63577daf&scoped=true&"
import script from "./DownLoadTip.vue?vue&type=script&lang=js&"
export * from "./DownLoadTip.vue?vue&type=script&lang=js&"
import style0 from "./DownLoadTip.vue?vue&type=style&index=0&id=63577daf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63577daf",
  null
  
)

export default component.exports